export default __webpack_public_path__ + "static/media/leftActive.9d2b1150.svg";